import React from 'react';
import { iconSizer } from "../../../../../icons2022/iconSizer";
import { WarningTriangleIcon24Regular } from "../../../../../icons2022/WarningTriangleIcon/WarningTriangleIcon24Regular";
import { WarningTriangleIcon32Regular } from "../../../../../icons2022/WarningTriangleIcon/WarningTriangleIcon32Regular";
import { WarningTriangleIcon64Regular } from "../../../../../icons2022/WarningTriangleIcon/WarningTriangleIcon64Regular";
export var ValidationWarningIcon = iconSizer({
  small: function small() {
    return /*#__PURE__*/React.createElement(WarningTriangleIcon24Regular, null);
  },
  medium: function medium() {
    return /*#__PURE__*/React.createElement(WarningTriangleIcon32Regular, null);
  },
  large: function large() {
    return /*#__PURE__*/React.createElement(WarningTriangleIcon64Regular, null);
  }
}, 'ValidationWarningIcon');